import { useEffect, useRef, useState } from 'react';

const SITE_KEY = 'ysc1_i54GrmxQ1dmcOZH5UFixzKsNz22lfsQJsbYo8gOtf4668a50';

let scriptLoaded = false;
function loadSmartCaptchaScript() {
  if (scriptLoaded || document.querySelector('script[src*="smartcaptcha"]')) {
    scriptLoaded = true;
    return;
  }
  const s = document.createElement('script');
  s.src = 'https://smartcaptcha.yandexcloud.net/captcha.js';
  s.async = true;
  s.defer = true;
  document.head.appendChild(s);
  scriptLoaded = true;
}

// Предзагрузка скрипта SmartCaptcha сразу при заходе на сайт (до открытия формы) —
// чтобы к моменту открытия формы заявки/вопроса скрипт уже был загружен.
export function preloadSmartCaptcha() {
  loadSmartCaptchaScript();
}

export function useSmartCaptcha(enabled = true, theme = 'light') {
  const containerRef = useRef(null);
  const widgetIdRef   = useRef(null);
  const [token, setToken] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    loadSmartCaptchaScript();
  }, [enabled]);

  // Зависимости [enabled, theme]. При смене темы виджет пересоздаётся (destroy + render)
  // с новым параметром theme — это официальный способ сменить тему у SmartCaptcha.
  // containerRef.current в deps НЕ добавляем — из-за этого виджет пересоздавался лишний раз
  // и первый клик «я не робот» не срабатывал.
  useEffect(() => {
    if (!enabled) return;

    let mounted = true;

    const render = () => {
      if (!mounted || !containerRef.current || widgetIdRef.current != null) return;
      if (typeof window.smartCaptcha === 'undefined') return;
      widgetIdRef.current = window.smartCaptcha.render(containerRef.current, {
        sitekey: SITE_KEY,
        hl: 'ru',
        theme, // 'light' | 'dark' | 'auto' — соответствует теме сайта
        callback: (t) => { if (mounted) { setToken(t); setReady(true); } },
        'token-expired-callback': () => { if (mounted) setToken(null); },
        'javascript-error-callback': () => { if (mounted) setToken(null); },
      });
    };

    // Ждём, пока подгрузится скрипт SmartCaptcha и контейнер окажется в DOM
    const interval = setInterval(() => {
      if (typeof window.smartCaptcha !== 'undefined' && containerRef.current) {
        clearInterval(interval);
        render();
      }
    }, 100);

    return () => {
      mounted = false;
      clearInterval(interval);
      if (widgetIdRef.current != null && typeof window.smartCaptcha !== 'undefined') {
        try { window.smartCaptcha.destroy(widgetIdRef.current); } catch {}
        widgetIdRef.current = null;
      }
      setToken(null);
      setReady(false);
    };
  }, [enabled, theme]);

  const reset = () => {
    setToken(null);
    setReady(false);
    if (widgetIdRef.current != null && typeof window.smartCaptcha !== 'undefined') {
      try { window.smartCaptcha.reset(widgetIdRef.current); } catch {}
    }
  };

  return { containerRef, token, ready, reset };
}
